import Token from "./Token";

class Session
{
    /**
     * Create a new session instance.
     * 
     * @return void
     */
    constructor()
    {
        let session = localStorage.getItem("_session");

        this.sessionExists = session != null && session !== undefined;

        if(this.sessionExists) {
            session = JSON.parse(session);
            this.accessToken = new Token(session.accessToken);
            this.expiration = session.expiration;
            this.refreshToken = new Token(session.refreshToken);
            this.refreshExpiration = session.refreshExpiration;
            this.sessionState = session.sessinState;
            this.tokenType = session.tokenType;
            this.notBeforePolicy = session.notBeforePolicy;
            this.scope = session.scope;
        }
    }

    /**
     * Checks whether the session exists in local storage or not.
     * 
     * @return {Boolean}
     */
    exists()
    {
        return this.sessionExists;
    }

    /**
     * Set the session from the response of the login request.
     * 
     * @param {Object} response
     * 
     * @return void
     */
    static set(response)
    {
        let sessionObject = response != null ? {
            accessToken: response.AccessToken,
            expiration: response.ExpiresIn,
            refreshToken: response.RefreshToken,
            refreshExpiration: response.RefreshExpiresIn,
            sessionState: response.SessionState,
            tokenType: response.TokenType,
            notBeforePolicy: response["not-before-policy"],
            scope: response.Scope
        } : null;

        localStorage.setItem("_session", JSON.stringify(sessionObject));
    }

    /**
     * Delete the session from the local storage.
     * 
     * @return {void}
     */
    static delete()
    {
        localStorage.removeItem("_session");
        this.sessionExists = false;
    }
}

export default Session;
